import React from 'react';

import Alert from './Alert';

import APIClient from './APIClient';

class ForgottenPasswordForm extends React.Component {
  emailField = React.createRef();

  state = {
    email: '',
    error: null,
    requested: false,
  };

  checkEmailMessage = <span>
    If that email address is registered, you will receive an email to reset your password.
    Be sure to check your junk/spam folders. <br />
    Should you encounter any issues, please email <a href="mailto:support@panelsapp.com">support@panelsapp.com</a>.
  </span>;

  handleEmailChange = (e) => {
    const email = (e.currentTarget.value || '').trim();
    this.setState({ email });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ error: null });

    const email = this.emailField.current.value;
    APIClient.shared.postForgotten(email)
      .then(() => this.setState({ requested: true }))
      .catch(error => this.setState({ error }))
  };

  render() {
    return (
      <div className="ForgottenPasswordForm">
        {this.state.requested &&
          <Alert title="Check your email" message={this.checkEmailMessage} />
        }
        {this.state.error &&
          <Alert title="Error" message={this.state.error.message} />
        }
        {!this.state.requested &&
          <form className="Form" onSubmit={this.handleSubmit}>
            <div className="Form__group">
              <label htmlFor="email">Email address</label>
              <input type="email" id="email" ref={this.emailField} onChange={this.handleEmailChange} />
            </div>

            <button type="submit" disabled={this.state.email.length === 0}>Send Link</button>
          </form>
        }
      </div>
    );
  }
}

export default ForgottenPasswordForm;



// WEBPACK FOOTER //
// ./src/ForgottenPasswordForm.js